export enum LocalAccessKeys {
  PETS = 'pets',
  NOTICE_SHOW = 'NoticeShow',
  FAVORITES = 'favorites',
  LOGGEDIN = 'loggedIn',
}
